import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { AboutSection } from "@/components/AboutSection";
import { ShopSection } from "@/components/ShopSection";
import { CustomisationSection } from "@/components/CustomisationSection";
import { InquirySection } from "@/components/InquirySection";
import { InstagramSection } from "@/components/InstagramSection";
import { ReviewsSection } from "@/components/ReviewsSection";
import { FAQSection } from "@/components/FAQSection";
import { MapSection } from "@/components/MapSection";
import { FooterSection } from "@/components/FooterSection";
import { SEOHead } from "@/components/SEOHead";
import { ParticleCanvas } from "@/components/ParticleCanvas";
import { localBusinessSchema, organizationSchema, websiteSchema, faqSchema } from "@/data/schemas";

export default function HomePage() {
  const homeSchema = [localBusinessSchema, organizationSchema, websiteSchema, faqSchema];

  return (
    <>
      <SEOHead
        title="Premium New Year Diaries, Planners & Corporate Gifts | Bengaluru"
        description="Emcee Sons is Bengaluru's trusted Super Stockist for Eagle Diaries since 1976. Shop 50+ premium New Year diaries, planners & journals. Gold foiling, page insertions & fully customised diaries for bulk corporate orders. Visit us on Avenue Road."
        path="/"
        schema={homeSchema}
      />
      <ParticleCanvas />
      <Navbar />
      <main className="relative z-10">
        <HeroSection />
        <AboutSection />
        <ShopSection />
        <CustomisationSection />
        <InquirySection />
        <FAQSection />
        <InstagramSection />
        <ReviewsSection />
        <MapSection />
      </main>
      <FooterSection />
    </>
  );
}
